import type ErrorHandlerChain from '../ErrorHandlerChain'

import ResponseError from '../error/ResponseError'
import ResponseErrorException from '../error/ResponseErrorException'
import ResponseErrorBizException from '../error/ResponseErrorBizException'
import ResponseErrorSessionException from '../error/ResponseErrorSessionException'

import readBlob from '../utils/readBlob'

export default class DivisionErrorHandler {
  async handle(error: Error, chain: ErrorHandlerChain) {
    if (error instanceof ResponseError) {
      const response = error.response
      if (response.status == 200) {
        const rawData = response.data
        let jsonData

        if (rawData instanceof Blob) {
          // 文件下载抛异常JSON，在Blob里面
          jsonData = await readBlob(rawData)
          jsonData = JSON.parse(jsonData)
          jsonData = JSON.parse(jsonData)
        } else {
          // 普通请求的异常JSON
          jsonData = rawData
        }

        const { success, errorcode, data, errortext } = jsonData
        if (errorcode === '-1') {
          throw new ResponseErrorException(errortext, error, response, jsonData)
        } else if (errorcode === '-2') {
          throw new ResponseErrorBizException(errortext, error, response, jsonData)
        } else if (errorcode === '-3') {
          throw new ResponseErrorSessionException(errortext, error, response, jsonData)
        } else {
          throw new ResponseErrorException(errortext, error, response, jsonData)
        }
      } else {
        let errortext = "'" + response.config.url + "' " + response.status + ' ' + response.statusText
        throw new ResponseErrorException(errortext, error, response, null)
      }
    }

    throw error
  }
}
